import React from 'react';
import _ from 'i18n';
import Icon, { ICON_MAPPINGS } from '../ui/Icon';

const Footer = () => (
  <footer id="footer">
    <div className="main-footer row align-center p-y-m">
      <div className="column small-2">
        <img alt="" src="/img/pictos/full-logo.svg" />
      </div>
      <div className="column small-3 footer__contact">
        <ul>
          <li><Icon name={ICON_MAPPINGS["icon-tt-facebook"]} size={29} className="icon-tt-facebook" /></li>
          <li><Icon name={ICON_MAPPINGS["icon-tt-linkedin"]} size={29} className="icon-tt-linkedin" /></li>
          <li><Icon name={ICON_MAPPINGS["icon-tt-instagram"]} size={29} className="icon-tt-instagram" /></li>
          <li><Icon name={ICON_MAPPINGS["icon-tt-contact"]} size={29} className="icon-tt-contact" /></li>
        </ul>
      </div>
      <div className="column small-6 footer__about">
        <p className="p-x-s">
          <b>Tamtam.pro </b>
          {_('about_us_content')}
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
